import React, { memo } from 'react';
import Image from 'next/image';
import assetLoader from '@utils/internalImageLoder';
import styles from './CarFinance.module.scss';

interface BenefitsCardProps {
  carFinanceValuePropositions: string[];
}

export const BenefitsCard = memo(({ carFinanceValuePropositions }: BenefitsCardProps) => {
  return (
    <div className={styles.benefitsCard}>
      {carFinanceValuePropositions.map((carFinanceValueProposition: string, idx: number) => (
        <div className={styles.benefitRow} key={idx}>
          <Image
            src={`${assetLoader()}/icons/tick_icon.svg`}
            alt="tick"
            width={20}
            height={20}
            loading="lazy"
          />
          <span className={styles.benefitText}>
            {carFinanceValueProposition}
          </span>
        </div>
      ))}
    </div>
  );
});

BenefitsCard.displayName = 'BenefitsCard';
